export default function CommonSkeletonLoader() {
  return (
    <div className="tw-animate-pulse tw-w-full tw-flex tw-space-x-4">
      <div className="tw-flex-1 tw-space-y-6 tw-py-1">
        <div className="tw-h-2 tw-bg-iron-800 tw-rounded"></div>
      </div>
    </div>
  );
}
